import * as React from "react";
const SvgFiRrThumbtack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-thumbtack_svg__a)">
      <path
        fill="#062147"
        d="M1 24a1 1 0 0 0 .707-.293l6.619-6.619 1.248 1.292a5.17 5.17 0 0 0 3.605 1.614 4 4 0 0 0 1.339-.227 3.63 3.63 0 0 0 2.435-3.122 8.5 8.5 0 0 0-.222-3.027l-.214-1.042a1 1 0 0 1 .264-.943l1.587-1.588a.34.34 0 0 1 .236-.1.17.17 0 0 1 .167.065 3.08 3.08 0 0 0 3.971.432 3 3 0 0 0 .379-4.565L18.2.954a3.085 3.085 0 0 0-3.938-.4 3 3 0 0 0-.38 4.565l.076.076a.31.31 0 0 1 0 .434l-1.6 1.6a1 1 0 0 1-.954.261l-.817-.209a8.6 8.6 0 0 0-3.082-.233A3.86 3.86 0 0 0 4.25 9.634a4 4 0 0 0 .928 4.2l1.758 1.82-6.643 6.64A1 1 0 0 0 1 24m5.135-13.7a1.86 1.86 0 0 1 1.578-1.264 6.622 6.622 0 0 1 2.374.181l.823.21a3.01 3.01 0 0 0 2.862-.785l1.6-1.6a2.31 2.31 0 0 0 0-3.262l-.076-.076a1 1 0 0 1 .134-1.528 1.084 1.084 0 0 1 1.356.19L21.71 7.29a1 1 0 0 1-.134 1.528 1.085 1.085 0 0 1-1.368-.2 2.2 2.2 0 0 0-1.584-.672 2.4 2.4 0 0 0-1.667.684l-1.586 1.587a3 3 0 0 0-.8 2.8l.219 1.058c.202.772.263 1.573.181 2.366a1.66 1.66 0 0 1-1.115 1.444 2.8 2.8 0 0 1-2.85-.9l-4.4-4.55a2.03 2.03 0 0 1-.471-2.135"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-thumbtack_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrThumbtack;
